export default __webpack_public_path__ + "static/media/Rastech-update-0.0775415e.png";